import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconOffers: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 22 22"
    sx={{
      color: COLORS.CERULEAN,
      width: 22, 
      height: 22,
      ...sx,
    }}
  >
    <path 
        d="M11.0023 0C4.93317 0 0 4.93214 0 11C0 17.0633 4.93317 22 11.0023 22C17.0714 22 22 17.0679 22 11C22 4.93214 17.0668 0 11.0023 0ZM11.0023 20.214C5.91797 20.214 1.7818 16.0787 1.7818 11C1.7818 5.92132 5.91797 1.78143 11.0023 1.78143C16.0866 1.78143 20.2182 5.91674 20.2182 10.9954C20.2182 16.0741 16.082 20.214 11.0023 20.214Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M18.7341 7.51047C18.3494 7.25402 14.6804 6.53504 12.1383 7.74861C12.097 7.76693 12.0604 7.78982 12.0237 7.81272C11.2222 7.54253 10.5259 7.67992 10.132 7.80814C10.0954 7.78524 10.0633 7.76693 10.0221 7.74403C7.4845 6.53046 3.81097 7.24944 3.42621 7.50589C3.11932 7.71197 3.03687 8.12413 3.24299 8.43096C3.31628 8.53629 3.41247 8.61872 3.5224 8.66909C3.51324 9.5163 3.74226 11.0367 5.27214 12.3602C5.73476 12.7586 6.29816 12.9647 6.91194 12.9647C7.23258 12.9647 7.56695 12.9097 7.91049 12.7952C9.21592 12.3648 10.3565 11.2016 10.6175 10.0338L10.6542 9.88266C10.7046 9.66285 10.7824 9.34686 10.7824 9.01714C10.9428 8.98508 11.1535 8.97592 11.3916 9.02172C11.3916 9.35144 11.4695 9.66285 11.5199 9.88266L11.5565 10.0338C11.8176 11.2061 12.9582 12.3648 14.2636 12.7952C14.6071 12.9097 14.9415 12.9647 15.2621 12.9647C15.8759 12.9647 16.4393 12.7586 16.9019 12.3602C18.4318 11.0367 18.6609 9.5163 18.6517 8.66909C18.7616 8.61872 18.8578 8.54087 18.9311 8.43096C19.1235 8.13329 19.041 7.71655 18.7341 7.51047Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M13.8972 14.7232C12.6055 16.0149 9.55486 16.0103 8.26317 14.7232C8.00209 14.4621 7.58068 14.4621 7.31959 14.7232C7.05851 14.9842 7.05851 15.4056 7.31959 15.6667C8.23569 16.5828 9.65563 17.0363 11.0802 17.0363C12.5047 17.0363 13.9292 16.5782 14.8407 15.6667C15.1018 15.4056 15.1018 14.9842 14.8407 14.7232C14.5796 14.4621 14.1582 14.4621 13.8972 14.7232Z"
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
